import React from "react";
import Label from "components/general/Label";
import Table from 'react-bootstrap/Table';
import { findArray } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const WreSummary = ({ data }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters();

  let home = findArray(data?.results?.items, { startSortOrder: [1] });
  let away = findArray(data?.results?.items, { startSortOrder: [2] });
  let homeColor = findArray(home?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] })?.eue_value?.toLowerCase();
  let awayColor = findArray(away?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] })?.eue_value?.toLowerCase();
  let homeUniform = homeColor.length > 1 ? 'uniform-color-' + homeColor : 'uniform-color-silver'
  let awayUniform = awayColor.length > 1 ? 'uniform-color-' + awayColor : 'uniform-color-silver'

  let current = data?.results?.extendedInfos?.find(filter => (filter.ei_code === 'PERIOD'))?.ei_value;

  let period1 = data?.results?.periods?.find(filter => (filter.p_code === 'P1'));
  let period1Order = period1?.extendedPeriods?.sort((a, b) => a.ep_pos - b.ep_pos);

  let period2 = data?.results?.periods?.find(filter => (filter.p_code === 'P2'));
  let period2Order = period2?.extendedPeriods?.sort((a, b) => a.ep_pos - b.ep_pos);

  let period1OrderHome = period1Order?.filter(filter => (filter.ep_code === 'H_TCP' && filter.ep_value != 'C'));
  let period1OrderAway = period1Order?.filter(filter => (filter.ep_code === 'A_TCP' && filter.ep_value != 'C'));

  let period2OrderHome = period2Order?.filter(filter => (filter.ep_code === 'H_TCP' && filter.ep_value != 'C'));
  let period2OrderAway = period2Order?.filter(filter => (filter.ep_code === 'A_TCP' && filter.ep_value != 'C'));

  let period1Home = Array.isArray(period1OrderHome) && period1OrderHome?.map((item, index) => {
    return (
      <div className={`wre-wrestler-box m-1 text-center text-white fw-bold ${homeUniform}`} key={"home-p1-" + index} >
        {item?.ep_value}
      </div>
    )
  })

  let period1Away = Array.isArray(period1OrderAway) && period1OrderAway?.map((item, index) => {
    return (
      <div className={`wre-wrestler-box m-1 text-center text-white fw-bold ${awayUniform}`} key={"away-p1-" + index} >
        {item?.ep_value}
      </div>
    )
  })

  let period2Home = Array.isArray(period2OrderHome) && period2OrderHome?.map((item, index) => {
    return (
      <div className={`wre-wrestler-box m-1 text-center text-white fw-bold ${homeUniform}`} key={"home-p2-" + index} >
        {item?.ep_value}
      </div>
    )
  })

  let period2Away = Array.isArray(period2OrderAway) && period2OrderAway?.map((item, index) => {
    return (
      <div className={`wre-wrestler-box m-1 text-center text-white fw-bold ${awayUniform}`} key={"away-p2-" + index} >
        {item?.ep_value}
      </div>
    )
  })


  return (
    <div className="">
      <Table striped bordered hover>
        <caption><Label data={'HeaderMatchSumary'} sport={mirs_discipline} /></caption>
        <thead>
          <tr>
            <th className="w-10 text-end">
              <Label data={'HeaderPeriod'} sport={mirs_discipline} />
            </th>
            <th className="w-35 text-end">
              <Label data={'HeaderTechnicalPointsScored'} sport={mirs_discipline} />
            </th>
            <td className="w-10"></td>
            <th className="w-45 text-start">
              <Label data={'HeaderTechnicalPointsScored'} sport={mirs_discipline} />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={`text-end ${current === 'P1' ? 'score-current' : ''}`}>
              <Label data={'Header1st'} sport={mirs_discipline} />
            </td>
            <td className="text-end">
              <div className="d-flex justify-content-end">{period1Home}</div>
            </td>
            <td></td>
            <td className="text-start">
              <div className="d-flex justify-content-start">{period1Away}</div>
            </td>
          </tr>
          <tr>
            <td className={`text-end ${current === 'P2' ? 'score-current' : ''}`}>
              <Label data={'Header2nd'} sport={mirs_discipline} />
            </td>
            <td className="text-end">
              <div className="d-flex justify-content-end">{period2Home}</div>
            </td>
            <td></td>
            <td className="text-start">
              <div className="d-flex justify-content-start">{period2Away}</div>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}

export default WreSummary;